// Recovered compiled webpack factory 48915. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "hasInterceptionRouteInCurrentTree", {
      enumerable: !0,
      get: function () {
        return function e(t) {
          let [r, a] = t;
          if (
            (Array.isArray(r) && ("di" === r[2] || "ci" === r[2])) ||
            ("string" == typeof r && (0, n.isInterceptionRouteAppPath)(r))
          )
            return !0;
          if (a) {
            for (let t in a) if (e(a[t])) return !0;
          }
          return !1;
        };
      },
    }));
  let n = r(57630);
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
